import React, {Component} from 'react';
import PropTypes from "prop-types";
import _ from "lodash";

import FormattedNumber from "../Controls/FormattedNumber";

import {VARIABLE_LABELS_LONG, TEXT} from '../../utilities/strings';
import {VARIABLES, SUMMARIES} from "../../utilities/constants";

/**
 * Component to render the summary table
 *
 * @example
 * <SummaryTable
 *   nationalData={this.props.nationalData}
 *   selectedState={this.props.selectedState}
 *   comparisonState={this.props.comparisonState}
 *   selectedCounty={this.props.selectedCounty}
 *   comparisonCounty={this.props.comparisonCounty}
 *   summaryType={this.props.summaryType}
 *  />
 */
export default class SummaryTable extends Component {

  static propTypes = {
    caption: PropTypes.string,
    nationalData: PropTypes.array,
    statesData: PropTypes.array,
    countiesData: PropTypes.array,
    summaryType: PropTypes.string,
    selectedState: PropTypes.object,
    comparisonState: PropTypes.object,
    selectedCounty: PropTypes.object,
    comparisonCounty: PropTypes.object,
  };

  getPivotData = () => {
    return _.chain([])
      .concat(this.props.nationalData)
      .concat(this.props.selectedState)
      .concat(this.props.comparisonState)
      .concat(this.props.selectedCounty)
      .concat(this.props.comparisonCounty)
      .compact()
      .value()
  }

  renderHeader = (category) => {
    const getValue = (item) => _.get(item, VARIABLES.Location)

    const dataCols = _.map(this.getPivotData(), (item, index) => (
      <th role="columnheader" scope="col" key={index} className="text-right">{getValue(item)}</th>
    ))

    return (
      <tr role="row">
        <th role="columnheader" scope="col" style={{width: 380}}>{category}</th>
        {dataCols}
      </tr>
    )
  };

  renderRow = (field, formatter = _.noop, padded) => {

    const getValue = (item) => formatter(_.get(item, field))

    const dataCols = _.map(this.getPivotData(), (item, index) => (
      // eslint-disable-next-line jsx-a11y/no-interactive-element-to-noninteractive-role
      <td role="cell" key={index} className="text-right">{getValue(item)}</td>
    ))

    return (
      <tr role="row">
        <th role="rowheader" scope="row" className={padded && 'pl-4'}>{VARIABLE_LABELS_LONG[field]}</th>
        {dataCols}
      </tr>
    )
  }

  render() {
    const showDetail = this.props.summaryType === SUMMARIES.DETAIL;

    return (
      <div className="table-responsive">
        <table className="table table-sm table-striped mb-3">
          <thead className="thead-dark">
          {this.renderHeader(TEXT.summary_title_total)}
          </thead>
          <tbody>
          {this.renderRow(VARIABLES.Cost_perCapita, FormattedNumber.renderCurrency)}
          {this.renderRow(VARIABLES.TotalCost, FormattedNumber.renderCurrency)}
          </tbody>
        </table>

        <table className="table table-sm table-striped mb-3">
          <thead className="thead-dark">
          {this.renderHeader(TEXT.summary_title_nonfatal)}
          </thead>
          <tbody>
          {this.renderRow(VARIABLES.OUD_Total, FormattedNumber.renderInteger)}
          {this.renderRow(VARIABLES.OUDC_Total, FormattedNumber.renderCurrency)}
          {showDetail && this.renderRow(VARIABLES.OUDC_HealthCare, FormattedNumber.renderCurrency, true)}
          {showDetail && this.renderRow(VARIABLES.OUDC_Treatment, FormattedNumber.renderCurrency, true)}
          {showDetail && this.renderRow(VARIABLES.OUDC_CriminalJustice, FormattedNumber.renderCurrency, true)}
          {showDetail && this.renderRow(VARIABLES.OUDC_LostProductivity, FormattedNumber.renderCurrency, true)}
          {showDetail && this.renderRow(VARIABLES.OUDC_RQL, FormattedNumber.renderCurrency, true)}
          </tbody>
        </table>

        <table className="table table-sm table-striped">
          <thead className="thead-dark">
          {this.renderHeader(TEXT.summary_title_fatal)}
          </thead>
          <tbody>
          {this.renderRow(VARIABLES.FOD_Total, FormattedNumber.renderInteger)}
          {this.renderRow(VARIABLES.FODC_Total, FormattedNumber.renderCurrency)}
          {showDetail && this.renderRow(VARIABLES.FODC_HealthCare, FormattedNumber.renderCurrency, true)}
          {showDetail && this.renderRow(VARIABLES.FODC_LostProductivity, FormattedNumber.renderCurrency, true)}
          {showDetail && this.renderRow(VARIABLES.FODC_VSL, FormattedNumber.renderCurrency, true)}
          </tbody>
        </table>

        <div className="table-footnote">{this.props.caption}</div>

      </div>
    )
  }
}
